/* eslint-disable import/no-anonymous-default-export */
const salesHeader = [
  { name: "invoiceDate", title: "Invoice Date" },
  { name: "invoiceID", title: "Invoice ID" },
  { name: "organizationName", title: "Client" },
  { name: "total", title: "Amount" },
];

const rebatesHeader = [
  { name: "date", title: "Date" },
  { name: "amount", title: "Amount" },
  { name: "comment", title: "Comment" },
];

const salaryHeader = [
  { name: "date", title: "Date" },
  { name: "amount", title: "Amount" },
  { name: "comment", title: "Comment" },
];

const otherExpensesHeader = [
  { name: "date", title: "Date" },
  { name: "category", title: "Category" },
  { name: "amount", title: "Amount" },
  { name: "invoice", title: "Invoice" },
  { name: "comment", title: "Comment" },
];

const jobHeader = [
  { name: "client", title: "Client " },
  { name: "jobStartDate", title: "Start Date" },
  { name: "jobEndDate", title: "End Date" },
];

const incomeList = [
  { name: "invoiceDate" || "createdAt", title: "Invoice Date" },
  { name: "invoiceID", title: "Invocie ID" },
  { name: "chequeNumber", title: "Cheque Number" },
  { name: "amount", title: "Amount" },
];
const paymentDues = [
  { name: "invoiceID", title: "Invocie ID" },
  { name: "invoiceDate" || "createdAt", title: "Invoice Date" },
  { name: "total", title: "Total Amount" },
  { name: "paid", title: "paid" },
  { name: "balance", title: "Balance" },
];

const salesHST = [
  { name: "invoiceID", title: "Invoice ID" },
  { name: "amount", title: "Amount" },
  { name: "hstPercentage", title: "HST (%)" },
  { name: "hstAmount", title: "HST Amount" },
];

export {
  salesHeader,
  rebatesHeader,
  salaryHeader,
  otherExpensesHeader,
  jobHeader,
  incomeList,
  paymentDues,
  salesHST,
};
